import { ReactElement } from 'react';
import { InfoCircleOutline } from '../../../../../components/icons';
import { CopyText } from '../../../../../components/CopyText';
import { Tooltip } from 'antd';

interface SummaryCardProp {
    isBank?: boolean;
    bankName?: string;
    accountNumber?: string;
    amount: string | number;
    currency: string;
    percent: number;
    trend: string;
    label: string;
    logo: ReactElement;
    message?: string;
}

const SummaryCard = ({ item }: { item?: SummaryCardProp }) => {
    return (
        <div className='w-full h-[146px] bg-white border border-appcolorfaintnine rounded-[24px] py-5 px-6 flex flex-col justify-between'>
            <div>
                {item?.isBank ? (
                    <div className='flex gap-2'>
                        {item?.logo}
                        <div>
                            <p className='text-gray700 text-[14px] leading-[20px] font-medium'>
                                {item?.bankName}
                            </p>
                            <div className='flex items-center gap-[4px]'>
                                <p className='text-gray700 text-[14px] leading-[20px] font-bold'>
                                    A/C No: {item?.accountNumber}{' '}
                                </p>
                                <CopyText
                                    text={item?.accountNumber || ''}
                                    color='#292D32'
                                />
                            </div>
                        </div>
                    </div>
                ) : (
                    item?.logo
                )}
            </div>
            <div>
                <Tooltip placement='topLeft' title={item?.message}>
                    <p className='text-gray700 text-[12px] leading-[18px] flex gap-[4px] items-center'>
                        {item?.label} <InfoCircleOutline />
                    </p>
                </Tooltip>
                <div className='flex justify-between items-end'>
                    <p className='text-gray700 text-[24px] leading-[32px] font-semibold'>
                        {item?.currency} {item?.amount?.toLocaleString()}{' '}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default SummaryCard;
